import { pastCA } from "./chiffreDAffaire.model";
import { CodeOrder } from "./code-order.model";
import { LabelValue } from "./liste.model";

export class CompteEntreprise {
    nom: string;
    adresse: string;
    adresseComp: string;
    codePostale: string;
    ville: string;
    pays: string;
    telephone: string;
    siren: string;
    typeLibelle: string;
    constructor() {
        
    }
}

export class Contact {
    genreLibelle: string;
    nom: string;
    prenom: string;
    fonctionLibelle: string;
    serviceLibelle: string;
    email: string;
    telpro: string;
    roles: string[];
}

export class Invitation {
    id : string;
    idContact: string;
    email: string;
    gender: string;
    lastName: string;
    firstName: string;
    profil : string[];
    isMainContact: boolean;
    isBillingContact: boolean;
    isDone: boolean;
}

export class CompanyMscompany {
    id: string;
    address: string;
    city: string;
    postalCode: string;
    countryCode: string;
    siren: string;
    name: string;
    customerNumber: string;
}

export class CompanyDetails {
    idCompany: string;
    accountNumber: string;
    companyName: string;
    typeCompte: string;
    isFDA?: boolean;
    isBadPayer?: boolean;
    gcp?: string;
    gln?: string;
    activite: LabelValue;
    accessFichePartenaire: string;
    name: string;
    siren: string;
    countryCode: string;
    customerNumber: string;
    companyParent?: CompanyDetails;
    address: string;
    address2: string;
    postalCode: string;
    city: string;
    country?: string;
    salesChannel: LabelValue;
    salesChannelsSecondary: LabelValue[];
    isBrandTiers: boolean;
    isBrandOwner: boolean;
    isWithoutBrand: boolean;
    turnovers: pastCA[];
    currentTurnover: pastCA;
    hasRequestCodeInProgress?: boolean;
    orders?: CodeOrder[];
    isAlowedOrderingGCP : boolean;
    isAlowedOrderingPvar : boolean;
    isAlowedOrderingGTIN8 : boolean;
    packId : string;
    leftOrderGtin8:number;
    leftOrderPvar:number;
    product: LabelValue;
}
